<script lang="ts">
import {defineComponent} from 'vue';
import DataCard from "../overview/DataCard.vue";
import BaseDoughnutChart from "./BaseDoughnutChart.vue";
import Tooltip from "../../components/tooltip.vue";


export default defineComponent({
  name: "DoughnutChartDataCard",
  components: {BaseDoughnutChart, DataCard, Tooltip},
  props: {
    /** Card Header Title */
    title: {
      type: String,
      required: true
    },
    /** Card Header Subtitle */
    subtitle: {
      type: String,
      required: true
    },
    /** Percents to display on left sidebar
     *  key, value of label => percentage (number)
     *  */
    percentData: {
      type: Object,
      default: () => ({})
    },
    /** Formatted Chart Data for the Doughnut chard
     * See BaseDoughnutChart.vue for formatting */
    chartData: {
      type: Object,
      required: true
    },

    /** Formats the tooltips as Moneh $$$ **/
    formatAsMoney: {
      type: Boolean,
      default: false
    },
    hideTooltip: {
      type: Boolean,
      default: false
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    /** Cache metadata object with cached_at and next_refresh ISO strings */
    cacheInfo: {
      type: Object,
      default: null
    },
  },
  computed: {
    // Extract chart colors from the dataset for sidebar label matching
    chartColors() {
      const bg = this.chartData?.datasets?.[0]?.backgroundColor;
      if (!bg) return [];
      if (typeof bg === 'function') return []; // dynamic color functions can't be extracted
      return Array.isArray(bg) ? bg : [bg];
    }
  },
  methods: {
    formatDate(isoString) {
      if (!isoString) return "";
      return new Date(isoString).toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    }
  }
});
</script>

<template>
  <DataCard
    class="donut-chart-data-card"
    left-sidebar
    compact
    :title="title"
    :additional-text="subtitle"
    loaded
  >
    <!-- inject only the tooltip icon into the existing header -->
    <template #leftSidebarExtras>
      <tooltip
        v-if="tooltipMessage"
        :message="tooltipMessage"
        variant="question"
        size="12px"
        class="ml-1"
        :position="{ maxWidth: '250px', transform: 'translateX(-50%)'}"
      />
    </template>

    <template #leftSidebar>
      <div
        v-if="percentData"
        class="flex flex-col"
      >
        <div v-for="(value, label, index) in percentData">
          <div class="additional-text">
            {{ label }}
          </div>
          <div
            v-if="value"
            class="text-3xl font-bold"
            :style="chartColors[index] ? { color: chartColors[index] } : {}"
            :class="!chartColors[index] ? (index % 2 === 0 ? 'text-default_primary' : 'text-default_secondary') : ''"
          >
            <!--               :style="chartColors[index] ? { color: chartColors[index] } : (!chartColors[index] && index % 2 !== 0 ? { color: '#2563EB' } : {})"-->

            {{ value }}
          </div>
          <div v-else>
            <div class="rounded-sm w-1/2 h-10 bg-gray-200 animate-pulse" />
          </div>
        </div>
      </div>
    </template>

    <div class="chart-container pie-chart-container">
      <base-doughnut-chart
        :data="chartData"
        no-data-message="Not enough data to report on."
        hide-labels
        :format-as-money="formatAsMoney"
        :hide-tooltip="hideTooltip"
      />
    </div>
  </DataCard>
</template>

<style scoped lang="scss">

.pie-chart-container {
  max-height: 200px;
}

.donut-chart-data-card {
  grid-column: span 1;
}

@media screen and (max-width: 1024px) {
  .donut-chart-data-card {
    grid-column: span 1;
  }
}

@media screen and (max-width: 640px) {
  .donut-chart-data-card {
    grid-column: span 1;
  }

  .pie-chart-container {
    max-height: 100px;
  }
}
</style>
